/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./HeaderTime.vue?vue&type=template&id=4d8a3e87&scoped=true"
import script from "./HeaderTime.vue?vue&type=script&lang=js"
export * from "./HeaderTime.vue?vue&type=script&lang=js"
import style0 from "./HeaderTime.vue?vue&type=style&index=0&id=4d8a3e87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a3e87",
  null
  
)

export default component.exports